import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineNotice = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100000] bg-red-600 text-white text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2" data-testid="offline-notice">
      <WifiOff size={16} />
      <span>You're offline. Some features may not be available.</span>
    </div>
  );
};

export default OfflineNotice;
